import { HttpClient } from '@angular/common/http';
import { BuilderInfoService, SuggestionsProvider } from '@portal/builder';
import { DadataSuggestionsMapperService } from './dadata-suggestions-mapper.service';
import { DadataSuggestionsService } from './dadata-suggestions.service';
import { NoopSuggestionsService } from './noop-suggestions.service';

export const suggestionsFactory = (http: HttpClient, builderInfo: BuilderInfoService) => {
  const provider = builderInfo.settings?.suggestionsProvider?.type ?? '';
  switch (provider) {
    case SuggestionsProvider.DADDATA:
      return new DadataSuggestionsService(
        new DadataSuggestionsMapperService(),
        http,
        builderInfo.settings.suggestionsProvider.key,
      );
    default:
      return new NoopSuggestionsService(null, http, null);
  }
};
